import React, { Component, ErrorInfo, ReactNode } from 'react';
import { RefreshCw, AlertCircle } from 'lucide-react';
import { Button } from './Button';

interface Props {
    children?: ReactNode;
    fallback?: ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false
    };

    public static getDerivedStateFromError(_: Error): State {
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
         // console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    private handleRetry = () => {
        this.setState({ hasError: false });
        window.location.reload();
    };

    public render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }

            return (
                <div className="flex flex-col items-center justify-center min-h-[400px] p-8 text-center bg-surface-alt dark:bg-surface-dark-alt rounded-3xl border-2 border-dashed border-border-default dark:border-border-default-dark m-4">
                    <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-full flex items-center justify-center mb-6">
                        <AlertCircle size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">Ops! Algo deu errado</h2>
                    <p className="text-gray-600 dark:text-gray-400 mb-8 max-w-md">
                        Não foi possível carregar este conteúdo no momento. Isso pode ser um problema temporário de conexão.
                    </p>
                    <Button
                        onClick={this.handleRetry}
                        variant="primary"
                        className="flex items-center gap-2"
                    >
                        <RefreshCw size={18} />
                        Tentar Novamente
                    </Button>
                </div>
            );
        }

        return this.props.children;
    }
}
